import type { KbMediaAsset } from "@/features/knowledge/types";

export interface MediaTreeNode extends KbMediaAsset {
  children: MediaTreeNode[];
}

/**
 * Assemble a flat media-asset list into a parent/child tree. Roots are the nodes
 * whose `parent` is not present in the set (so a subtree fetched on its own still
 * nests correctly). Siblings keep their `display_seq` order from the API.
 */
export function buildTree(items: KbMediaAsset[]): MediaTreeNode[] {
  const byId = new Map<string, MediaTreeNode>();
  for (const item of items) byId.set(item.id, { ...item, children: [] });

  const roots: MediaTreeNode[] = [];
  for (const node of byId.values()) {
    const parent = node.parent ? byId.get(node.parent) : undefined;
    if (parent) parent.children.push(node);
    else roots.push(node);
  }
  return roots;
}
